"use client";

import React, { useEffect, useState } from "react";

import { SearchV2 } from "./components/SearchV2";

export const Search = (): JSX.Element => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const isOpen = document.body.classList.contains("search-panel--open");
      setIsSearchOpen(isOpen);
    });

    observer.observe(document.body, { attributes: true });

    return () => observer.disconnect();
  }, []);

  const handleClose = (isOpen: boolean) => {
    const firstButton = document.querySelector(
      `button[aria-controls="search-panel"]`
    );
    const isExpanded = firstButton?.getAttribute("aria-expanded") === "true";
    if (isOpen === isExpanded) {
      return;
    }

    const button: HTMLButtonElement | null = document.querySelector(
      `button[aria-controls="search-panel"]`
    );
    if (button) {
      button.click();
    }
  };

  return (
    <SearchV2
      isSearchOpen={isSearchOpen}
      closeSearch={() => {
        handleClose(false);
        setIsSearchOpen(false);
      }}
    />
  );
};

/*
useState in this component is a workaround for the fact that the existing Search component requires its props to be set (rather than using CSS to toggle visibility)
It will be removed once the Search component is re-written with Vanilla Extract.
*/
